import { Button, CircularProgress } from "@mui/material";
import axios from "axios";
import { useContext, useState } from "react";
import { UserContext } from "../contexts/UserContext";
import { prependUserToSelectNote } from "../utils/prependUserToSelectNote";
import { RequestedTaskDescription } from "./types";

interface Props {
  actionLabel: "Requested" | "Confirmed";
  noteText: string;
  onError: (message: string) => void;
  onSaved: () => Promise<void>;
  orderNumber: string;
  taskDescription: RequestedTaskDescription;
}

export default function SurveyZoningActionButton({
  actionLabel,
  noteText,
  onError,
  onSaved,
  orderNumber,
  taskDescription
}: Props) {
  const { user } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  const save = async () => {
    if (!user) {
      onError("Unable to determine the current user.");
      return;
    }

    setIsLoading(true);

    try {
      await axios.post("/proxy/api/orders/AddNoteToRequestedTask", {
        orderNumber,
        taskDescription,
        text: prependUserToSelectNote(noteText, user.name)
      });

      await onSaved();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        onError(
          typeof error.response?.data === "string"
            ? error.response.data
            : error.response?.data?.message || `Unable to mark ${actionLabel.toLowerCase()}.`
        );
      } else {
        onError(`Unable to mark ${actionLabel.toLowerCase()}.`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="text"
      size="small"
      color="secondary"
      onClick={save}
      disabled={isLoading}
      endIcon={isLoading ? <CircularProgress size={16} /> : undefined}
    >
      {actionLabel}
    </Button>
  );
}
